import _ from 'lodash';
import { ConvoNode } from '../types/chatBot';

// Utility function to merge conversation data - extracted exactly from Customer.Layout.tsx
export function mergeConvo(
  base: Record<string, ConvoNode>,
  over: Partial<Record<string, Partial<ConvoNode>>>
): Record<string, ConvoNode> {
  const merged = _.cloneDeep(base);
  Object.entries(over).forEach(([key, nodeOverride]: any) => {
    if (!merged[key]) return;
    if (nodeOverride.text) merged[key].text = nodeOverride.text;
    if (nodeOverride.next) merged[key].next = nodeOverride.next;
    if (nodeOverride.input) merged[key].input = nodeOverride.input;
    if (nodeOverride.attachment) merged[key].attachment = nodeOverride.attachment;
    if (Array.isArray(nodeOverride.options)) {
      merged[key].options = nodeOverride.options.map((o: any, i: number) => {
        const defaultOption = base[key]?.options?.[i];
        return {
          text: o.text,
          next: o.next || defaultOption?.next, // Preserve default 'next' if not provided
          action: o.action || defaultOption?.action // Preserve default 'action' if not provided
        };
      });
    }
  });
  return merged;
}

export const maxPreviewFiles = 8; 